import { render } from "./FirstIconView.vue?vue&type=template&id=1fc38fee&ts=true"
import script from "./FirstIconView.vue?vue&type=script&lang=ts"
export * from "./FirstIconView.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__